<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.251 26.25H8.75098C3.75098 26.25 2.50098 25 2.50098 20V10C2.50098 5 3.75098 3.75 8.75098 3.75H21.251C26.251 3.75 27.501 5 27.501 10V20C27.501 25 26.251 26.25 21.251 26.25Z" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.501 9.99805H23.751" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18.75 15H23.75" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M21.251 20.002H23.751" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.6277 14.109C11.8773 14.109 12.8902 13.096 12.8902 11.8465C12.8902 10.5969 11.8773 9.58398 10.6277 9.58398C9.37819 9.58398 8.36523 10.5969 8.36523 11.8465C8.36523 13.096 9.37819 14.109 10.6277 14.109Z" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.001 20.4117C14.826 18.5992 13.3885 17.1742 11.576 17.0117C10.951 16.9492 10.3135 16.9492 9.67598 17.0117C7.86348 17.1867 6.42598 18.5992 6.25098 20.4117" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
